import React from 'react';
import { CalendarRange, Shield } from 'lucide-react';
import { cn } from '../../lib/utils';

function FilterPill({ active, onClick, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'rounded-full border px-3 py-1.5 text-[10px] font-bold uppercase tracking-wide transition-all',
        active
          ? 'de-nav-pill-active border-de-gold/50 text-de-gold'
          : 'border-de-gold/15 bg-black/25 text-de-muted hover:border-de-gold/30 hover:text-slate-200',
      )}
    >
      {children}
    </button>
  );
}

export default function OverviewUnifiedFilters({
  temporalMode,
  onTemporalModeChange,
  securitySeverityFilter,
  onSecuritySeverityChange,
  onSecurityRefresh,
  onSecurityExport,
  securityRefreshing,
  refreshLabel,
  refreshingLabel,
  exportLabel,
}) {
  return (
    <div className="de-ultra-card p-4 sm:p-5">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="min-w-0 flex-1">
          <p className="m-0 flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.2em] text-de-gold/80">
            <CalendarRange className="h-3.5 w-3.5" />
            सर्व पॅनेलसाठी एकच ग्रुपिंग
          </p>
          <p className="m-0 mt-1 text-xs text-de-muted">
            Machine, Revenue, Alerts, Security आणि Telemetry — एकाच वेळी बदलेल
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            {[
              { id: 'hour', label: 'Hour-wise' },
              { id: 'day', label: 'Day-wise' },
              { id: 'month', label: 'Month-wise' },
            ].map(({ id, label }) => (
              <FilterPill key={id} active={temporalMode === id} onClick={() => onTemporalModeChange(id)}>
                {label}
              </FilterPill>
            ))}
          </div>
        </div>

        <div className="shrink-0 border-t border-de-gold/15 pt-4 lg:border-l lg:border-t-0 lg:pl-5 lg:pt-0">
          <p className="m-0 flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.2em] text-de-gold/80">
            <Shield className="h-3.5 w-3.5" />
            Security filter
          </p>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            {['ALL', 'HIGH', 'MEDIUM'].map((level) => (
              <FilterPill
                key={level}
                active={securitySeverityFilter === level}
                onClick={() => onSecuritySeverityChange(level)}
              >
                {level}
              </FilterPill>
            ))}
            <button
              type="button"
              className="rounded-lg border border-de-gold/35 bg-de-gold/10 px-3 py-1.5 text-[10px] font-bold text-de-gold disabled:opacity-60"
              onClick={onSecurityRefresh}
              disabled={securityRefreshing}
            >
              {securityRefreshing ? refreshingLabel : refreshLabel}
            </button>
            <button
              type="button"
              className="rounded-lg border border-emerald-500/40 bg-emerald-500/10 px-3 py-1.5 text-[10px] font-bold text-emerald-400"
              onClick={onSecurityExport}
            >
              {exportLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
